import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.firebasestorage.app`,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let app: any = null;
let auth: any = null;

if (
  import.meta.env.VITE_FIREBASE_API_KEY &&
  import.meta.env.VITE_FIREBASE_PROJECT_ID &&
  import.meta.env.VITE_FIREBASE_APP_ID
) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
}

const provider = new GoogleAuthProvider();

export function isFirebaseConfigured(): boolean {
  return auth !== null;
}

export interface GoogleSignInResult {
  user: { id: string; email: string | null; name: string | null; photoURL: string | null };
  accessToken: string | null;
}

/** Opens Google sign-in popup. Returns user data or null on cancel/error. */
export async function signInWithGoogle(): Promise<GoogleSignInResult | null> {
  if (!auth) {
    console.error("Firebase not configured — Google login unavailable");
    return null;
  }
  try {
    const result = await signInWithPopup(auth, provider);
    const credential = GoogleAuthProvider.credentialFromResult(result);
    return {
      user: {
        id: result.user.uid,
        email: result.user.email,
        name: result.user.displayName,
        photoURL: result.user.photoURL,
      },
      accessToken: credential?.accessToken ?? null,
    };
  } catch (error: any) {
    if (error.code === "auth/popup-closed-by-user") return null;
    console.error("Google sign-in error:", error);
    throw error;
  }
}
